import React, { useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import MemboticLogo from "../../../assets/MemboticLogo.png";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function LoginOrSignUpModal({ cancelModal }) {
  //styled

  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e) => {

    setIsLoading(true)
    e.preventDefault();

    if (username.length == 0 || password.length == 0) {
      setLoginErr("Username and password must both be filled in");
      return;
    }

    const loginDetails = { username, password };
    setSubmitting(true);

    try {
      const loginResponse = await axios.post(
        `${ApiConnectionString}/api/users/login/`,
        loginDetails
      );

      if (loginResponse.status === 200) {
        dispatch({ type: "LOGIN", payload: loginResponse.data });
        cancelModal();
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setLoginErr(error.response.data); // Adjusted to handle the error message
      } else {
        // Handle other errors if needed
        console.error(error);
      }
    } finally {
      setSubmitting(false);
      setIsLoading(false)
    }
  };

  
if (isLoading) {
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <LoadingSpinner />
      </div>
    </div>
  );
}
else{
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <form onSubmit={handleSubmit} className="login-form">
          <div className="text-center">
            {" "}
            <img
              src={MemboticLogo}
              className="logo"
              alt="Membotic"
              title="Membotic"
            />
          </div>

          <p className="text-center">Log in to Membotic to continue</p>
          <label>
            <span>Username or Email:</span>
            <input
              onChange={(e) => setUsername(e.target.value)}
              value={username}
            />
          </label>
          <label>
            <span>password:</span>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </label>
          {!submitting ? (
            <button className="btn btn-primary btn-lg">Login</button>
          ) : (
            <button className="btn btn-primary btn-lg" disabled>
              Loading
            </button>
          )}
          <div className="d-flex">
            <p>Not a member?</p>
            <Link to="/Register" className="text-decoration-none mx-2">
              Signup now
            </Link>
          </div>
          {loginErr && <p className="text-danger">{loginErr}</p>}
        </form>
        <div className="send-modal-footer"></div>

        <button
          type="button"
          className="btn-close position-absolute top-0 end-0 m-3"
          aria-label="Close"
          onClick={cancelModal}
        ></button>
      </div>
    </div>
  );
}
}